import { render, staticRenderFns } from "./Tariffs.vue?vue&type=template&id=1ca0f1cf&scoped=true"
import script from "./Tariffs.vue?vue&type=script&lang=ts"
export * from "./Tariffs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca0f1cf",
  null
  
)

export default component.exports